import { FC } from 'react';
import Box from 'yoda-ui/components/Box';

const FormLayoutMidPanelContent: FC = ({ children }) => {
  return (
    <Box
      width="100%"
      display="flex"
      flexDirection="column"
    >
      { children }
    </Box>
  );
};

export default FormLayoutMidPanelContent;
